import i18next from 'i18next';

export const STORE_COLUMN = () => ({
  name: i18next.t('ADMIN.RECIPES.EXPORT_BY_STORE_STORE_COLUMN'),
  propertyKey: 'storeName',
});

export const VARIANT_COLUMN = () => ({
  name: i18next.t('ADMIN.RECIPES.EXPORT_BY_STORE_VARIANT_COLUMN'),
  propertyKey: 'variantName',
});

export const INFO_SHEET_STORE_COLUMN = () => ({
  name: i18next.t('ADMIN.RECIPES.EXPORT_BY_STORE_INFO_STORES_COLUMN'),
  propertyKey: 'storeName',
});
